import React from "react";

export const RANGES = [
  { id: "7d", label: "7 Days" },
  { id: "28d", label: "28 Days" },
  { id: "90d", label: "90 Days" },
  { id: "year", label: "This Year" },
];

export const rangeStartDate = (range) => {
  const now = new Date();
  if (range === "year") return new Date(now.getFullYear(), 0, 1);
  const days = { "7d": 7, "28d": 28, "90d": 90 }[range] || 28;
  return new Date(Date.now() - days * 864e5);
};

export const inRange = (iso, range) => {
  const d = new Date(iso);
  return !isNaN(d) && d >= rangeStartDate(range);
};

export const fmtN = (n) => Number(n || 0).toLocaleString();

export const timeAgo = (iso) => {
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `${mins}m ago`;
  const h = Math.floor(mins / 60);
  if (h < 48) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

export function RangeToggle({ range, setRange }) {
  return (
    <div className="flex border border-white/10" data-testid="dash-range-toggle">
      {RANGES.map((r) => (
        <button
          key={r.id}
          onClick={() => setRange(r.id)}
          data-testid={`range-${r.id}`}
          className={`px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.16em] transition-colors ${
            range === r.id ? "bg-[#9D0423] text-white" : "text-neutral-400 hover:text-white hover:bg-white/5"
          }`}
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}

export function Tile({ label, value, sub, alert = false, testid }) {
  return (
    <div className={`bg-[#0D0D0F] p-5 border ${alert ? "border-[#9D0423]" : "border-white/5"}`} data-testid={testid}>
      <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-500">{label}</div>
      <div className={`mt-2 font-heading font-extrabold text-3xl leading-none ${alert ? "text-[#E56A79]" : "text-white"}`}>{value}</div>
      {sub && <div className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.1em] text-neutral-500">{sub}</div>}
    </div>
  );
}

export function Card({ title, right, children, testid, className = "" }) {
  return (
    <div className={`bg-[#0D0D0F] border border-white/5 p-6 ${className}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-4 mb-5">
        <h3 className="font-heading font-extrabold uppercase text-base text-white tracking-tight">{title}</h3>
        {right}
      </div>
      {children}
    </div>
  );
}

export function HBar({ pct, color = "#9D0423" }) {
  return (
    <div className="h-2 bg-white/5 overflow-hidden">
      <div className="h-full transition-[width] duration-500" style={{ width: `${Math.min(100, pct)}%`, backgroundColor: color }} />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, children, testid }) {
  return (
    <div className="bg-[#0D0D0F] border border-dashed border-white/15 p-10 text-center" data-testid={testid}>
      {Icon && <Icon size={26} className="mx-auto text-[#9D0423]" />}
      <h3 className="mt-4 font-heading font-extrabold uppercase text-lg text-white tracking-tight">{title}</h3>
      <div className="mt-3 text-[13px] text-neutral-400 leading-relaxed max-w-lg mx-auto">{children}</div>
    </div>
  );
}

export function Loading() {
  return (
    <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
      {[...Array(8)].map((_, i) => (
        <div key={i} className="bg-[#0D0D0F] p-5 h-24 animate-pulse" />
      ))}
    </div>
  );
}
